import { AB_VARIANTS } from "@/constants/analytics.constants";
import { ABVariants } from "@/types/common.types";

export function useFareFamilyFlowAB() {
  return {
    isControlTreatment: true,
    variant: AB_VARIANTS.OFF as ABVariants,
  };
}
